import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import pickingService from "../Services/pickingService";
import warehouseService from "../Services/warehouseService";
import locationService from "../Services/locationService";

const ViewPickingList = () => {

    const [picking, setPicking] = useState()
    const [list, setList] = useState({})
    const [boxes, setBoxes] = useState([])
    const [loading, setLoading] = useState(false);
    const [currentBox, setCurrentBox] = useState(null)

    const [warehouses, setWarehouses] = useState([])
    const [locations, setLocations] = useState([])

    const [data, setData] = useState({
        stock: 0,
        warehouse: 0,
        location: 0,
        product: 0,
    })
    const [errors, setErrors] = useState({
        stock: false,
        warehouse: false,
        location: false,
        product: false
    })

    const navigate = useNavigate()
    const location = useLocation()

    const ID = new URLSearchParams(location.search).get("id")

    useEffect(() => {
        const getPickings = async () => {
            try {
                setLoading(true)
                const response = await pickingService.fetch(ID)
                setPicking(response.picking)
                setLoading(false)
            } catch {

            }
        }
        getPickings()
    }, [])

    useEffect(() => {
        const getWarehouses = async () => {
            const response = await warehouseService.fetchAll()
            console.log(response)
            setWarehouses(response.warehouses)
        }
        getWarehouses()
    }, []);

    useEffect(() => {
        const getLocations = async () => {
            const response = await locationService.getLocationByWarehouse(1)
            console.log(response)
            setLocations(response.locations)
        }
        getLocations()
    }, [data.warehouse]);

    useEffect(() => {
        if (picking) {
            let array = []
            for (const item of picking.details) {
                if (!array.includes(item.box)) {
                    array.push(item.box)
                    list[item.box] = []
                    list[item.box].push(item)
                } else {
                    list[item.box].push(item)
                }
            }
            setBoxes(array)
        }
    }, [picking]);

    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (box) => {
        setCurrentBox(currentBox === box ? null : box);
    };

    const handleChange = (e) => {
        setData(d => ({...d, [e.target.name]: e.target.value}))
        setErrors(errs => ({...errs, [e.target.name]: false}))
    }

    return (
        <>
            {boxes.map(box => (

                <div id="accordion-open" data-accordion="open" className="mx-16 my-10">
                    <h2 id="accordion-open-heading-1">
                        <button
                            type="button"
                            className={`flex items-center justify-between w-full p-5 font-medium rtl:text-right border bg-gray-100 border-gray-200 rounded-t-xl dark:text-gray-400 hover:bg-gray-100 gap-3 ${activeIndex === 1 ? 'text-blue-600' : 'text-gray-500'}`}
                            onClick={() => handleToggle(box)}
                            aria-expanded={currentBox === box}
                            aria-controls="accordion-open-body-1"
                        >
      <span className="flex items-center">
        Box No. {box}
      </span>
                            <svg
                                className={`w-3 h-3 rotate-180 shrink-0 ${currentBox === box ? 'rotate-180' : ''}`}
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 10 6"
                            >
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="M9 5 5 1 1 5"/>
                            </svg>
                        </button>
                    </h2>
                    <div
                        id="accordion-open-body-1"
                        className={`p-5 border border-gray-200 rounded-b-md ${currentBox === box ? '' : 'hidden'}`}
                        aria-labelledby="accordion-open-heading-1"
                    >
                        <tbody>
                        {list[box].map((value, index) => (
                            <tr key={index}>
                                <td className="w-[10%] px-4 py-2 text-xs font-semibold">{value.vendor_code}</td>
                                <td className="w-[15%] px-4 py-2 text-xs font-regular">{value.title}</td>
                                <td className="w-[7%] px-4 py-2 text-xs font-semibold">{`${value.quantity === 1 ? `${value.quantity} Pc` : `${value.quantity} Pcs`}`} </td>
                                <td className="w-[5%] px-4 py-2">
                                    <input
                                        type="number"
                                        placeholder="0"
                                        className="border-2 px-4 py-2 rounded-xl text-xs focus:outline-primary hover:border-primary hover:border-opacity-50 hover:outline-primary border-gray-200 w-16"
                                    />
                                </td>
                                <td className="w-[15%] px-4 py-1">
                                    <select
                                        value={data.warehouse}
                                        name="warehouse"
                                        onChange={(e) => handleChange(e)}
                                        className={`border-2 px-4 py-2 rounded-xl text-xs focus:outline-primary hover:border-primary hover:border-opacity-50 hover:outline-primary border-gray-200 w-full ${errors['warehouse'] ? "border-red-600" : "border-gray-300"}`}
                                    >
                                        <option disabled={true} value="">Select Warehouse</option>
                                        {warehouses.map(value => (
                                            <option key={value.id} value={value.id}>{value.name}</option>
                                        ))}
                                    </select>
                                </td>
                                <td className="w-[15%] px-4 py-2">
                                    <select
                                        value={data.location}
                                        name="warehouse"
                                        onChange={(e) => handleChange(e)}
                                        className={`border-2 px-4 py-2 rounded-xl text-xs focus:outline-primary hover:border-primary hover:border-opacity-50 hover:outline-primary border-gray-200 w-full ${errors['warehouse'] ? "border-red-600" : "border-gray-300"}`}
                                    >
                                        <option disabled={true} value="">Select Location</option>
                                        {locations.map(value => (
                                            <option key={value.id} value={value.id}>{value.name}</option>
                                        ))}
                                    </select>
                                </td>
                                <td className="w-[10%] px-4 py-2">
                                    <button className="bg-primary rounded-lg text-xs text-white px-10 py-2">Place</button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </div>
                </div>
            ))}
        </>

    );
};

export default ViewPickingList;
